export const MAX_PANEL_ITEMS = 5

export const viewAllClassName = 'text-[12px] font-medium text-primary hover:underline'
